<template>
  <div class="contact-section">
    <v-container
      style="height: 100%"
      class="d-flex align-center justify-center"
    >
      <v-row>
        <v-col
          cols="12"
          class="d-flex align-center justify-center"
          data-aos="fade-down"
        >
          <h2>
            <span>وسائل التواصل</span>
          </h2>
        </v-col>
        <v-row class="mt-10">
          <v-row class="d-flex justify-center align-center">
            <v-col
              cols="12"
              sm="12"
              md="6"
              lg="6"
              xl="6"
              class="px-8 d-flex align-center justify-center"
            >
              <div class="main">
                <div class="up">
                  <a href="https://wa.link/j8v8ll" target="_blank">
                    <button
                      class="card1"
                      data-aos="fade-down-right"
                      data-aos-duration="500"
                    >
                      <svg
                        class="whatsapp"
                        fill="#000000"
                        height="30px"
                        width="30px"
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 308 308"
                      >
                        <g id="XMLID_468_">
                          <path
                            id="XMLID_469_"
                            d="M227.904,176.981c-0.6-0.288-23.054-11.345-27.044-12.781c-1.629-0.585-3.374-1.156-5.23-1.156
		c-3.032,0-5.579,1.511-7.563,4.479c-2.243,3.334-9.033,11.271-11.131,13.642c-0.274,0.313-0.648,0.687-0.872,0.687
		c-0.201,0-3.676-1.431-4.728-1.888c-24.087-10.463-42.37-35.624-44.877-39.867c-0.358-0.61-0.373-0.887-0.376-0.887
		c0.088-0.323,0.898-1.135,1.316-1.554c1.223-1.21,2.548-2.805,3.83-4.348c0.607-0.731,1.215-1.463,1.812-2.153
		c1.86-2.164,2.688-3.844,3.648-5.79l0.503-1.011c2.344-4.657,0.342-8.587-0.305-9.856c-0.531-1.062-10.012-23.944-11.02-26.348
		c-2.424-5.801-5.627-8.502-10.078-8.502c-0.413,0,0,0-1.732,0.073c-2.109,0.089-13.594,1.601-18.672,4.802
		c-5.385,3.395-14.495,14.217-14.495,33.249c0,17.129,10.87,33.302,15.537,39.453c0.116,0.155,0.329,0.47,0.638,0.922
		c17.873,26.102,40.154,45.446,62.741,54.469c21.745,8.686,32.042,9.69,37.896,9.69c0.001,0,0.001,0,0.001,0
		c2.46,0,4.429-0.193,6.166-0.364l1.102-0.105c7.512-0.666,24.02-9.22,27.775-19.655c2.958-8.219,3.738-17.199,1.77-20.458
		C233.168,179.508,230.845,178.393,227.904,176.981z"
                          />
                          <path
                            id="XMLID_470_"
                            d="M156.734,0C73.318,0,5.454,67.354,5.454,150.143c0,26.777,7.166,52.988,20.741,75.928L0.212,302.716
		c-0.484,1.429-0.124,3.009,0.933,4.085C1.908,307.58,2.943,308,4,308c0.405,0,0.813-0.061,1.211-0.188l79.92-25.396
		c21.87,11.685,46.588,17.853,71.604,17.853C240.143,300.27,308,232.923,308,150.143C308,67.354,240.143,0,156.734,0z
		 M156.734,268.994c-23.539,0-46.338-6.797-65.936-19.657c-0.659-0.433-1.424-0.655-2.194-0.655c-0.407,0-0.815,0.062-1.212,0.188
		l-40.035,12.726l12.924-38.129c0.418-1.234,0.209-2.595-0.561-3.647c-14.924-20.392-22.813-44.485-22.813-69.677
		c0-65.543,53.754-118.867,119.826-118.867c66.064,0,119.812,53.324,119.812,118.867
		C276.546,215.678,222.799,268.994,156.734,268.994z"
                          />
                        </g>
                      </svg>
                    </button>
                  </a>
                  <a href="https://www.facebook.com/Farweb1" target="_blank">
                    <button
                      class="card2"
                      data-aos="fade-down-left"
                      data-aos-duration="500"
                    >
                      <svg
                        class="facebook"
                        fill="#000000"
                        height="30px"
                        width="30px"
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 310 310"
                        xml:space="preserve"
                      >
                        <g id="XMLID_834_">
                          <path
                            id="XMLID_835_"
                            d="M81.703,165.106h33.981V305c0,2.762,2.238,5,5,5h57.616c2.762,0,5-2.238,5-5V165.765h39.064
		c2.54,0,4.677-1.906,4.967-4.429l5.933-51.502c0.163-1.417-0.286-2.836-1.234-3.899c-0.949-1.064-2.307-1.673-3.732-1.673h-44.996
		V71.978c0-9.732,5.24-14.667,15.576-14.667c1.473,0,29.42,0,29.42,0c2.762,0,5-2.239,5-5V5.037c0-2.762-2.238-5-5-5h-40.545
		C187.467,0.023,186.832,0,185.896,0c-7.035,0-31.488,1.381-50.804,19.151c-21.402,19.692-18.427,43.27-17.716,47.358v37.752H81.703
		c-2.762,0-5,2.238-5,5v50.844C76.703,162.867,78.941,165.106,81.703,165.106z"
                          />
                        </g>
                      </svg>
                    </button>
                  </a>
                </div>
                <div class="down">
                  <a
                    href="https://youtube.com/@bigdev_404?si=HysU94cCd6WOWWyv"
                    target="_blank"
                  >
                    <button
                      class="card3"
                      data-aos="fade-up-right"
                      data-aos-duration="500"
                    >
                      <svg
                        class="youtube"
                        fill="#000000"
                        height="30px"
                        width="30px"
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 310 310"
                        xml:space="preserve"
                      >
                        <g id="XMLID_822_">
                          <path
                            id="XMLID_823_"
                            d="M297.917,64.645c-11.19-13.302-31.85-18.728-71.306-18.728H83.386c-40.359,0-61.369,5.776-72.517,19.938
		C0,79.663,0,100.008,0,128.166v53.669c0,54.551,12.896,82.248,83.386,82.248h143.226c34.216,0,53.176-4.788,65.442-16.527
		C304.633,235.518,310,215.863,310,181.835v-53.669C310,98.471,309.159,78.006,297.917,64.645z M199.021,162.41l-65.038,33.991
		c-1.454,0.76-3.044,1.137-4.632,1.137c-1.798,0-3.592-0.484-5.181-1.446c-2.992-1.813-4.819-5.056-4.819-8.554v-67.764
		c0-3.492,1.822-6.732,4.808-8.546c2.987-1.814,6.702-1.938,9.801-0.328l65.038,33.772c3.309,1.718,5.387,5.134,5.392,8.861
		C204.394,157.263,202.325,160.684,199.021,162.41z"
                          />
                        </g>
                      </svg>
                    </button>
                  </a>
                  <a
                    href="https://www.linkedin.com/in/braa-refaat-315557247/"
                    target="_blank"
                  >
                    <button
                      class="card4"
                      data-aos="fade-up-left"
                      data-aos-duration="500"
                    >
                      <svg
                        class="linkedin"
                        fill="#000000"
                        height="30px"
                        width="30px"
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 310 310"
                        xml:space="preserve"
                      >
                        <g id="XMLID_801_">
                          <path
                            id="XMLID_802_"
                            d="M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73
		C77.16,101.969,74.922,99.73,72.16,99.73z"
                          />
                          <path
                            id="XMLID_803_"
                            d="M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4
		c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z"
                          />
                          <path
                            id="XMLID_804_"
                            d="M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599
		c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319
		c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995
		C310,145.43,300.549,94.761,230.454,94.761z"
                          />
                        </g>
                      </svg>
                    </button>
                  </a>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-row>
      </v-row>
    </v-container>
  </div>
</template>
<script setup>
import { onMounted } from "vue";
import AOS from "aos";

onMounted(() => {
  AOS.init();
});
</script>

<style lang="scss" scoped>
.contact-section {
  height: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  padding: 30px 0;

  h2 {
    width: fit-content;
    color: #e8e5da;
    text-decoration: none;
    font-size: 30px;
    font-weight: 800;
  }

  h2::before {
    margin-right: auto;
  }

  h2::after,
  h2::before {
    content: "";
    width: 0%;
    height: 4px;
    background: #20bf55;
    display: block;
    transition: 0.5s;
  }

  h2:hover::after,
  h2:hover::before {
    width: 100%;
  }
  .v-card {
    width: 90% !important;
    border-radius: 8px;
    box-shadow: 2px 2px 10px #20bf55;
    transition: 0.4s all ease-in-out;
    &:hover {
      transform: scale(1.1);
      box-shadow: 1px 1px 20px #20bf55 !important;
    }
    .v-card-title {
      text-wrap: wrap;
    }
  }
  .main {
    display: flex;
    flex-direction: column;
    gap: 0.5em;
  }

  .up {
    display: flex;
    flex-direction: row;
    gap: 0.5em;
  }

  .down {
    display: flex;
    flex-direction: row;
    gap: 0.5em;
  }

  .card1 {
    width: 90px;
    height: 90px;
    outline: none;
    border: none;
    background: white;
    border-radius: 90px 5px 5px 5px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
      rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    transition: 0.2s ease-in-out;
  }

  .whatsapp {
    margin-top: 1.5em;
    margin-left: 1.2em;
    fill: #20bf55;
  }

  .card2 {
    width: 90px;
    height: 90px;
    outline: none;
    border: none;
    background: white;
    border-radius: 5px 90px 5px 5px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
      rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    transition: 0.2s ease-in-out;
  }

  .facebook {
    margin-top: 1.5em;
    margin-left: -0.9em;
    fill: #1877f2;
  }

  .card3 {
    width: 90px;
    height: 90px;
    outline: none;
    border: none;
    background: white;
    border-radius: 5px 5px 5px 90px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
      rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    transition: 0.2s ease-in-out;
  }

  .youtube {
    margin-top: -0.6em;
    margin-left: 1.2em;
    fill: #ff0000;
  }

  .card4 {
    width: 90px;
    height: 90px;
    outline: none;
    border: none;
    background: white;
    border-radius: 5px 5px 90px 5px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
      rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    transition: 0.2s ease-in-out;
  }

  .linkedin {
    margin-top: -0.9em;
    margin-left: -1.2em;
    fill: #0077b5;
  }

  .card1:hover {
    cursor: pointer;
    scale: 1.1;
    background-color: #20bf55;
    box-shadow: 1px 1px 0px #a4cab1, 2px 2px 0px #62aa7a, 3px 3px 0px #62aa7a,
      4px 4px 0px #62aa7a, 5px 5px 0px #62aa7a;
  }

  .card1:hover .whatsapp {
    fill: white;
  }

  .card2:hover {
    cursor: pointer;
    scale: 1.1;
    background-color: #1877f2;
    box-shadow: 1px 1px 0px #8fb9f0, 2px 2px 0px #589df6, 3px 3px 0px #589df6,
      4px 4px 0px #589df6, 5px 5px 0px #589df6;
  }

  .card2:hover .facebook {
    fill: white;
  }

  .card3:hover {
    cursor: pointer;
    scale: 1.1;
    background-color: #ff0000;
    box-shadow: 1px 1px 0px #ff8e8e, 2px 2px 0px #fa6262, 3px 3px 0px #fa6262,
      4px 4px 0px #fa6262, 5px 5px 0px #fa6262;
  }

  .card3:hover .youtube {
    fill: white;
  }

  .card4:hover {
    cursor: pointer;
    scale: 1.1;
    background-color: #0077b5;
    box-shadow: 1px 1px 0px #568aa6, 2px 2px 0px #3a86ae, 3px 3px 0px #3a86ae,
      4px 4px 0px #3a86ae, 5px 5px 0px #3a86ae;
  }

  .card4:hover .linkedin {
    fill: white;
  }

  .card1,
  .card2,
  .card3,
  .card4 {
    box-shadow: 1px 1px 0px rgb(179, 175, 175), 2px 2px 0px rgb(179, 175, 175),
      3px 3px 0px rgb(179, 175, 175), 4px 4px 0px rgb(179, 175, 175),
      5px 5px 0px rgb(179, 175, 175);
  }
}

/* media queries */

@media (min-width: 600px) {
  .main,
  .up,
  .down {
    gap: 1em !important;
  }
  .card1 {
    width: 190px !important;
    height: 190px !important;
  }
  .card2 {
    width: 190px !important;
    height: 190px !important;
  }
  .card3 {
    width: 190px !important;
    height: 190px !important;
  }
  .card4 {
    width: 190px !important;
    height: 190px !important;
  }
  .whatsapp,
  .facebook,
  .youtube,
  .linkedin {
    width: 70px !important;
    height: 70px !important;
  }
}

@media (max-width: 960px) {
  .v-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>
